import { Text } from '@rsos/base-components';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';

const ToastMessage = ({
  selectedCallerID,
}: {
  selectedCallerID: null | string;
}) => {
  if (!selectedCallerID) return null;

  return (
    <Text>
      Event details from{' '}
      <Text fontWeight="bold" inline>
        {formatInternationalPhoneNumberHuman(selectedCallerID)}
      </Text>{' '}
      were shared to field responders.
    </Text>
  );
};

export default ToastMessage;
